import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const AdminProtected = ({ children }) => {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div
        data-testid="admin-loading"
        className="min-h-screen bg-[#f8faf9] flex items-center justify-center"
      >
        <div className="w-8 h-8 rounded-full border-2 border-[#2b8a7e] border-t-transparent animate-spin" />
      </div>
    );
  }

  if (!user || user.role !== "admin") {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }

  return children;
};
